import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Optional,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MediaService } from '../services/http-services/media.service';

const FALLBACK_SRC = './assets/images/icons/ftn-icon.svg';

@Directive({
  selector: 'img[appImageSrc]'
})
export class ImageSrcDirective implements OnChanges, OnDestroy {

  @Input() appImageSrc: string | null | undefined;
  @Input() fallbackImageSrc: string = FALLBACK_SRC;

  private destroy$ = new Subject<void>();

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private media: MediaService,
    @Optional() private renderer: Renderer2
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appImageSrc'] || changes['fallbackImageSrc']) {
      this.destroy$.next();
      this.resolveAndSetSrc();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private resolveAndSetSrc(): void {
    const path = (this.appImageSrc ?? '').toString().trim();
    if (!path || path === 'null' || path === 'undefined') {
      this.setSrc(this.fallbackImageSrc);
      return;
    }
    if(path.startsWith('http://') || path.startsWith('https://')) {
      this.setSrc(path);
      return;
    }
    this.media
      .getMediaUrl(path)
      .pipe(takeUntil(this.destroy$))
      .subscribe((url) => {
        this.setSrc(url || this.fallbackImageSrc);
      });
  }

  private setSrc(url: string): void {
    const img = this.el.nativeElement;
    if (this.renderer) {
      this.renderer.setAttribute(img, 'src', url);
    } else {
      img.src = url;
    }
  }
}
